import { useDispatch, useSelector } from 'react-redux'
import { selectStrategyBuilderTab, selectViewTabs } from '../../../selectors/strategyBuilder'
import { StrategyBuilderTab } from '../header'
import StrategyBuilderPayoffView from '../strategyBuilderPayoffView'
import OptionChainTab from '../../../pages/home/optionChainTab'
import React, { memo, useEffect } from 'react'
import { setSelectedTab } from '../../../reducer/strategyBuilder.reducer'
import { OptionChainViewKey } from '../../../assets/constants'
import LiveStrategyBuilderContainer from '../liveStrategyBuilderContainer'
import StrategyChartTab from '../strategyChart/StrategyChartTab.tsx'

interface Props {
    simulator: boolean,
}

const StrategyBuilderTabView: React.FC<Props> = ({ simulator }) => {
    const selectedTab = useSelector(selectStrategyBuilderTab)
    const viewTabs = useSelector(selectViewTabs)
    const dispatch = useDispatch()

    useEffect(() => {
        if (simulator) return
        if (selectedTab !== StrategyBuilderTab.Payoff && !viewTabs) {
            dispatch(setSelectedTab(StrategyBuilderTab.Payoff))
        }
    }, [viewTabs, simulator, selectedTab, dispatch])

    return (
        <LiveStrategyBuilderContainer>
            {selectedTab === StrategyBuilderTab.Payoff && <StrategyBuilderPayoffView simulator={simulator} />}
            {selectedTab === StrategyBuilderTab.OptionChain && (
                <OptionChainTab optionChainViewKey={simulator ? OptionChainViewKey.HISTORICAL : OptionChainViewKey.LIVE} />
            )}
            {selectedTab === StrategyBuilderTab.StrategyChart && <StrategyChartTab />}
        </LiveStrategyBuilderContainer>
    )
}

export default memo(StrategyBuilderTabView)
